import React, { useState, useEffect } from "react";
import { axios } from "../../../utils";

import VideoOverlay from "./VideoOverlay";
import dynamic from "next/dynamic";

const YoutubeIframe = dynamic(
  () => import("../../../components/Organisms/YoutubeIframe"),
  { ssr: false }
);
import theme from "../../../foundation/Theme";
import EnrollNowButton from "../../../components/Molecules/EnrollNowButton";

import {
  NutritionistVideoWrapper,
  SubTitle,
  Title,
  YoutubeContainer,
} from "./style";

function NutritionistVideo({ data, scrollToForm }) {
  let { title, subTitle, videoUrl, thumbnail: thumbnailImage } = data || {};

  const [thumbnail, setThumbnail] = useState(thumbnailImage);
  const [showOverlay, setShowOverlay] = useState(true);
  const [videoId, setVideoId] = useState("");

  useEffect(() => {
    if (videoUrl) {
      const youtubeIDParser = (url) => {
        const regExp =
          /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[7].length === 11 ? match[7] : false;
      };

      const _videoId = youtubeIDParser(videoUrl);
      setVideoId(_videoId);

      if (!thumbnailImage) {
        const url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${_videoId}&format=json`;
        axios.get(url).then((res) => {
          setThumbnail(res?.thumbnail_url);
        });
      }
    }
  }, [videoUrl, thumbnailImage]);

  return (
    <NutritionistVideoWrapper>
      <Title variant="heading4" color={theme?.colorsV2?.shyft?.purple_text}>
        {title}
      </Title>
      <SubTitle variant="label1" color={theme?.colorsV2?.blueGray?.shade_800}>
        {subTitle}
      </SubTitle>
      <YoutubeContainer>
        {showOverlay ? (
          <VideoOverlay
            thumbnail={thumbnail}
            onCLickHandler={() => setShowOverlay(false)}
          />
        ) : (
          <YoutubeIframe
            videoId={videoId}
            showControls
            callBack={() => setShowOverlay(true)}
          />
        )}
      </YoutubeContainer>
      <EnrollNowButton content="Enroll Now" onClick={scrollToForm} />
    </NutritionistVideoWrapper>
  );
}

NutritionistVideo.propTypes = {};

NutritionistVideo.defaultProps = {};

export default NutritionistVideo;
